import styled from "styled-components";

import DoramImg from "./img/expanded/icon_jobs_4218.gif"


function NewRacesQuests() {
    return(<>
            <ClassListContainer>
                <ClassListItem>
                    <ClassListIcon iconImage={DoramImg}/>
                    <ClassListDescription>Doram </ClassListDescription>
                </ClassListItem>
            </ClassListContainer>
        </>
    )
}

const ClassListContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 300px;
    margin: 30px 0;
`

const ClassListItem = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    width: 250px;
    padding: 8px;
    margin: 2px 0;
    transition: .2s ease-in-out;

    cursor: url('cursors0007.png'), pointer;

    &:active {
        cursor: url('cursors0008.png'), pointer; 
     }

     &:hover {
        background-color: rgba(137, 151, 164, 1);
        color: white;
        scale: 1.2;
    }
`

const ClassListIcon = styled.div`
    background-image: url(${props => props.iconImage});
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    width: 25px;
    height: 25px;
    //border: solid 1px rgba(0,0,0,1)
`

const ClassListDescription = styled.span`
    width: 200px;
    height: 25px;
`



export default NewRacesQuests;